module.exports = __webpack_public_path__ + "img/dino.4ebcf03c.png";